import {
  CREATED,
  DECLINE,
  PURCHASE_BILL,
  TARIFF,
  SUBSCRIPTION,
  CARD_ICON_TYPE
} from './const';

export function getIconType({ status, type }) {
  const statusByBill = status === CREATED || status === DECLINE;

  if (type === PURCHASE_BILL && statusByBill) {
    return 'bill';
  }

  return CARD_ICON_TYPE[type];
}

export function getBillType({ type }) {
  if (type === SUBSCRIPTION) {
    return 'subscription';
  }

  if (type === TARIFF) {
    return 'tariff';
  }

  return '';
}

export function getMultiBillType({ multiBill, type, billPaymentEnabled }) {
  if (!multiBill) {
    return '';
  }

  if (type === PURCHASE_BILL) {
    return '';
  }

  return billPaymentEnabled ? 'multi-on' : 'multi-off';
}

export function getBillTypeText() {
  if (this.billType === SUBSCRIPTION) {
    return 'Счёт-подписка';
  }

  if (this.billType === TARIFF) {
    return 'Счёт с тарифами';
  }

  return this.isMulti ? 'Мультисчёт' : 'Счёт';
}

export function getAttributeFrom(stringElement, attr) {
  let div = document.createElement('div');
  div.innerHTML = stringElement;

  let el = div.firstElementChild;
  let res = el.getAttribute(attr);

  div.remove();
  el.remove();

  return res;
}
